import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("变更团队")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("变更财务岗位成本")

import { ref, Ref, onActivated, onBeforeMount } from 'vue'
import { useRoute} from 'vue-router'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'POST/salaries/costs': fetchList,
  // 用户下拉列表
  'GET/users/list': usersListApi,
  // 团队
  'GET/organizations': orgListApi,
  // 变更成本所属的团队
  'POST/salaries/costs/change/org': modifyApi,
  // 获取财务岗位下拉
  'GET/user_finances': financialJobListApi,
  // 变更成本所属的财务岗位
  'POST/salaries/costs/change/position': changePositionApi,
} = Api
const { 
  MI_tableData, fetchData, page, size,
  MI_total, MI_pageChange, MI_sizeChange,
  MI_identify, MI_params, MI_modifyForm
} = new tbMix(fetchList)
const route = useRoute()
const searchEle = ref()

let fullUserList: Ref<object[]> = ref([])
let financialJobList: Ref<object[]> = ref([])
onBeforeMount(() => {
  usersListApi().then((_userList: object[]) => {
    fullUserList.value = _userList.map((_user: any) => {
      _user.fullname = _user.realName + '(' + _user.username + ')'
      return _user
    })
  })
  financialJobListApi().then((rep: any) => {
    financialJobList.value = rep
  })
})


const searchConfig = ref([
  {
    type: 'SELECT',
    label: '姓名',
    value: '',
    upKey: 'userId',
    options: fullUserList,
    placeholder: '请选择姓名',
    rule: [
      { required: true, message: '必选项', trigger: 'change' },
    ],
    seleProps: {
      label: 'fullname',
      valueName: 'userId',
    }
  },
  {
    type: "TIME",
    label: "时间",
    value: '',
    upKey: 'timeRange',
    upProps: { startKey: 'startDate', endKey: 'endDate', },
    props: {
      'value-format': 'YYYY-MM-DD',
      type: 'daterange',
      clearable: true,
    },
    rule: [
      { required: true, message: '必选项', trigger: 'change' },
    ],
  },
])

const searchHandle = (params: any) => {
  fetchData(params, {}, 1)
}

onActivated(() => {
  if(route.params.month){
    searchEle.value.dataObj.userId = parseInt(route.params.userId as string)
    searchEle.value.dataObj.timeRange = [
      dayjs(route.params.month as string).startOf('month').format('YYYY-MM-DD'),
      dayjs(route.params.month as string).endOf('month').format('YYYY-MM-DD')
    ]

    searchHandle({
      userId: route.params.userId,
      startDate: dayjs(route.params.month as string).startOf('month').format('YYYY-MM-DD'),
      endDate: dayjs(route.params.month as string).endOf('month').format('YYYY-MM-DD'),
    })
  }
})
const modifyRows = ref<object[]>([])
const handleSelectionChange = (val: object[]) => {
  modifyRows.value = val
}

// 变更团队成本
const modifyFg = ref<boolean>(false)
const modifyConfig = ref([
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: [],
    placeholder: '请选择团队',
    selectFunc: orgListApi,
    rule: [
      { required: true, message: '必选项', trigger: 'change' },
    ],
    seleProps: {
      label: 'name',
      valueName: 'id',
    },
    props: { placeholder: '请选择团队', clearable: true }
  },
])
const modifyTeam = async () => {
  MI_modifyForm({}, modifyConfig, modifyFg, async (params: any) => {
    if(modifyRows.value.length <= 0){
      ElMessage.warning('请至少选择一条数据')
      return
    }
    await modifyApi({
      costIds: modifyRows.value.reduce((arr: any, item: any) => {
        arr = arr.concat(item.costIds)
        return arr
      }, []),
      orgId: params.orgId
    })
    fetchData(MI_params)
    modifyFg.value = false
    ElMessage.success('修改成功')
  })
}

const financialFg = ref<boolean>(false)
const financialConfig = ref([
  {
    type: 'SELECT',
    label: '财务岗位',
    value: '',
    upKey: 'positionId',
    options: financialJobList,
    props: { placeholder: '', clearable: false },
    seleProps: {
      label: 'name',
      valueName: 'id',
    }
  },
])
const modifyFinancial = async () => {
  MI_modifyForm({}, financialConfig, financialFg, async (params: any) => {
    if(modifyRows.value.length <= 0){
      ElMessage.warning('请至少选择一条数据')
      return
    }
    await changePositionApi({
      costIds: modifyRows.value.reduce((arr: any, item: any) => {
        arr = arr.concat(item.costIds)
        return arr
      }, []),
      ...params,
    })
    fetchData(MI_params)
    financialFg.value = false
    ElMessage.success('成功')
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_button, {
      class: "mb-10 mt-10",
      type: "info",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({ path: '/cost-table', query: { refresh: 'true'} })))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "成本修改" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
              ref_key: "searchEle",
              ref: searchEle
            }, {
              title: true,
              searchConfig: searchConfig.value,
              initSearch: false,
            }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      class: "mt-10 mb-10",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (modifyTeam()))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      class: "mt-10 mb-10",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (modifyFinancial()))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      onSelectionChange: handleSelectionChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, {
          label: "日期",
          prop: "date"
        }),
        _createVNode(_component_el_table_column, {
          label: "团队",
          prop: "orgName"
        }),
        _createVNode(_component_el_table_column, {
          label: "财务岗位",
          prop: "position"
        }),
        _createVNode(_component_el_table_column, {
          label: "类别",
          prop: "categoryName"
        }),
        _createVNode(_component_el_table_column, {
          label: "金额",
          prop: "amount"
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      title: "成本修改",
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modifyFg).value = $event))
    }, {
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: modifyConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "变更财务岗位成本",
      modelValue: financialFg.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((financialFg).value = $event))
    }, {
      default: _withCtx(() => [
        (financialFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: financialConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})